// src/services/axiosMiddleware.ts
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_BASE_URL;

const BASE_URL = apiUrl || 'http://localhost:8000/api';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(config => {
  config.url = `${BASE_URL}${config.url}`;
  return config;
});

export default axiosInstance;